import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { DataService } from '../../../@core/services/data.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CtaNewsletterInterface } from '../../../@core/models/site-material-data.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GoogleAnalyticsService } from '../../../@core/services/google-analytics.service';
import { AnalyticsService } from '../../../@core/services/analytics.service';
import * as Sentry from "@sentry/browser";


@Component({
  selector: 'app-cta-newsletter',
  templateUrl: './cta-newsletter.component.html',
  styleUrls: ['./cta-newsletter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MaterialCtaNewsletterComponent implements OnInit, OnDestroy {

  newsletterFormGroup: FormGroup;
  title: string;
  text: string;
  titleSize: string;
  textSize: string;
  activatePadding: boolean = false;
  textColor: string = '';
  titleColor: string = '';
  fontWeight: string = '';
  backgroundColor: string;
  loading$ = new BehaviorSubject<string>('false');
  // tslint:disable-next-line:max-line-length
  consentText = "By clicking the button bellow, you hereby acknowledge that we will process your personal information in accordance with our";
  buttonText: string = 'Get Started';
  mailChimpId: string;
  subscription: Subscription;
  errorMessage: string;
  data: CtaNewsletterInterface;
  position: number = 0;
  moduleInfo: string;
  privacyPolicyExist: boolean = false;
  privacyPolicyLink: string = '';
  successMsg$ = new BehaviorSubject<string>('');
  successMsg: string = '';
  allElementAnimation: string;
  textAnimation: string;
  formAnimation: string;
  loadingData$ = new BehaviorSubject<boolean>(false);

  constructor(private dataService: DataService, private fb: FormBuilder, private analyticsService: AnalyticsService, private googleAnalyticsService: GoogleAnalyticsService, private _snackBar: MatSnackBar) { }

  ngOnInit() {
    Sentry.configureScope(function (scope) {
      scope.setTag("component", "CtaNewsletterComponent");
    });
    if (this.data.animation) {
      this.allElementAnimation = this.data.animation.allElement != '' ? this.data.animation.allElement : undefined;
      this.textAnimation = this.data.animation.text != '' ? this.data.animation.text : undefined;
      this.formAnimation = this.data.animation.form != '' ? this.data.animation.form : undefined;

    }
    this.loadingData$.next(true)
    this.moduleInfo = JSON.stringify({ position: this.position, new: false });
    this.initForm();
    this.title = this.data.title;
    this.backgroundColor = this.data.backgroundColor ? this.data.backgroundColor : '';
    this.text = this.data.text;
    this.fontWeight = this.data.fontWeight;
    this.titleSize = this.data.titleSize ? this.data.titleSize : '';
    this.textSize = this.data.textSize;
    this.successMsg = this.data.successMsg ? this.data.successMsg : "Thanks for joining our newsletter!";
    this.titleColor = this.data.titleColor ? this.data.titleColor : this.data.textColor;
    this.textColor = this.data.textColor ? this.data.textColor : this.dataService.getDefaultColor(this.backgroundColor);
    if (this.data.consentText !== '' || this.data.consentText !== null) {
      this.consentText = this.data.consentText;
    }
    this.buttonText = this.data.buttonText;
    this.subscription = this.dataService.getCurrentSite().subscribe(site => {
      this.privacyPolicyExist = site.privacyPolicy ? true : false;
      this.privacyPolicyLink = "https://" + (site.domainName ? site.domainName : site.siteUrl) + '/privacy-policy';
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  initForm(): void {
    this.newsletterFormGroup = this.fb.group({
      email: ['', Validators.compose([
        Validators.required,
        Validators.email
      ])],
      consent: [false]
    });
  }

  isFormInvalid(): boolean {
    const controls = this.newsletterFormGroup.controls;
    if (controls['consent'].value === true && this.newsletterFormGroup.valid) {
      this.errorMessage = undefined;
      return false;
    } else if (this.newsletterFormGroup.dirty && this.newsletterFormGroup.invalid) {
      this.errorMessage = 'Please fill in all the required fields.';
      return true;
    } else if (this.newsletterFormGroup.dirty && this.newsletterFormGroup.valid && controls['consent'].value === false) {
      this.errorMessage = 'Please read and agree to our privacy policy by checking the box.';
      return true;
    } else {
      return true;
    }
  }
  submitForm() {
    this.loading$.next('true');
    const _this = this;
    this.subscription = this.dataService.getSiteId().subscribe(siteId => {
      this.dataService.postNewsletter({
        siteId,
        email: this.newsletterFormGroup.get("email").value
      }).subscribe(res => {
        this.loading$.next('false');
        this.successMsg$.next(this.successMsg);
        const currentSite = this.dataService.site$.getValue();
        if (currentSite) {
          this.analyticsService.trackConversion(currentSite, 'conversion');
        }
        if (currentSite.googleAnalyticsPixel) {
          this.googleAnalyticsService.eventEmitter('newsletter_sub', 'newsletter_sub', 'newsletter_subsription_' + siteId, 'leads');
        }
        if (currentSite.facebookPixel) {
          this.googleAnalyticsService.FbEventEmitter('Lead', 'lead', 'NewsLetter', 'newsletter_sub');
        }
        this._snackBar.open('Thanks for joining our newsletter!', '', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center',
          panelClass: ['info-snackbar']
        });
      }, err => {
        this.loading$.next('false');
        this._snackBar.open(err.error.message, '', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center',
          panelClass: ['danger-snackbar']
        });
      });
    });
  }
  setConsentChecked() {
    this.newsletterFormGroup.controls['consent'].setValue(!this.newsletterFormGroup.controls['consent'].value);
  }
}
